import React from 'react'
import { FormattedMessage } from 'react-intl'

const style = {
  position: 'absolute',
  color: '#fdfdfd',
  zIndex: 99999,
  textAlign: 'center',
  fontWeight: 'bold',
  bottom: 0,
  marginBottom: '15px',
  marginLeft: '35px',
  backgroundColor: '#f17823',
  padding: '4px',
  borderRadius: '4px',
}

const TutorialModeMessage = () => (
  <span style={style}>
    <FormattedMessage id="tutorial.common_texts.tutorial_mode" defaultMessage="Tutorial Mode" />
  </span>
)

export default TutorialModeMessage
